import { Camera } from 'react-bytesize-icons';
import overviewDark from "../../../../assets/images/docs/screenshots/overview-dark.png";
import screenshotoverview from "../../../../assets/images/docs/screenshot-overview.png";
import screenshotsingle from "../../../../assets/images/docs/screenshot-single.png";
import padding from "../../../../assets/images/docs/screenshots/padding.png";
import crop from "../../../../assets/images/blogs/pp12/crop.mp4";
import delay from "../../../../assets/images/blogs/pp12/delay.mp4";
import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import screenshotdefaultaction from "../../../../assets/images/docs/screenshots/defaultaction.png";
import * as React from 'react';
export default {
  Camera,
  overviewDark,
  screenshotoverview,
  screenshotsingle,
  padding,
  crop,
  delay,
  ShortCutDisplay,
  screenshotdefaultaction,
  React
};